import { getApiBaseUrl,getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getProductionReport(cookies, inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/production_report?plant_ids=${inputs.plant_ids}&customer_ids=${inputs.customer_ids}&consignee_ids=${inputs.consignee_ids}&sales_rep_ids=${inputs.sales_rep_ids}&vehicle_ids=${inputs.vehicle_ids}&product_ids=${inputs.product_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
  .then(response => response.data);
}

export async function getGstReport(cookies, inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/gst_report?plant_id=${inputs.plant_id}&customer_ids=${inputs.customer_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
  .then(response => response.data);
}

export async function getProductionReportCSV(cookies, inputs) {
  return getApiClient(cookies).get(`${apiBaseUrl}/production_report`, {
    params: {
      plant_ids: inputs.plant_ids,
      customer_ids: inputs.customer_ids,
      consignee_ids: inputs.consignee_ids,
      sales_rep_ids: inputs.sales_rep_ids,
      vehicle_ids: inputs.vehicle_ids,
      product_ids: inputs.product_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

const REPORT_REQUEST_TIMEOUT_MS = 180000;

export async function getDispatchReport(cookies,inputs) {
  return getApiClient(cookies, { timeout: REPORT_REQUEST_TIMEOUT_MS })
  .get(`${apiBaseUrl}/dispatch_report`, {
    timeout: REPORT_REQUEST_TIMEOUT_MS,
    params: {
      plant_ids: inputs.plant_ids,
      customer_ids: inputs.customer_ids,
      consignee_ids: inputs.consignee_ids,
      sales_rep_ids: inputs.sales_rep_ids,
      vehicle_ids: inputs.vehicle_ids,
      product_ids: inputs.product_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      report_format: inputs.report_format,
      report_type: inputs.report_type || 'detailed',
    },
  })
  .then(response => response.data);
}

export async function getGoodsReceiptNoteReport(cookies,inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/goods_receipt_note_report?plant_ids=${inputs.plant_ids}&vendor_ids=${inputs.vendor_ids}&vehicle_ids=${inputs.vehicle_ids}&product_ids=${inputs.product_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}&report_format=${inputs.report_format}&report_type=${inputs.report_type || 'detailed'}`)
  .then(response => response.data);
}

export async function getDispatchReportSummary(cookies,inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/dispatch_report_summary?plant_ids=${inputs.plant_ids}&customer_ids=${inputs.customer_ids}&consignee_ids=${inputs.consignee_ids}&sales_rep_ids=${inputs.sales_rep_ids}&product_ids=${inputs.product_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}&report_format=${inputs.report_format}&download_option=${inputs.download_option}`)
  .then(response => response.data);
}

export async function getDispatchReportPDF(cookies,inputs) {
  return getApiClient(cookies, { timeout: REPORT_REQUEST_TIMEOUT_MS }).get(`${apiBaseUrl}/dispatch_report`, {
    params: {
      plant_ids: inputs.plant_ids,
      customer_ids: inputs.customer_ids,
      consignee_ids: inputs.consignee_ids,
      sales_rep_ids: inputs.sales_rep_ids,
      vehicle_ids: inputs.vehicle_ids,
      product_ids: inputs.product_ids,
      report_format: inputs.report_format,
      report_type: inputs.report_type || 'detailed',
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      download_option: 'pdf',
    },
  }).then(response => response.data);
}

export async function getGrnReportPDF(cookies,inputs) {
  let url= `${apiBaseUrl}/goods_receipt_note_report?plant_ids=${inputs.plant_ids}&vendor_ids=${inputs.vendor_ids}&vehicle_ids=${inputs.vehicle_ids}&product_ids=${inputs.product_ids}&report_format=${inputs.report_format}&report_type=${inputs.report_type || 'detailed'}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}&download_option=pdf`
    return getApiClient(cookies).get(url)
      .then(response => response.data);
}
export async function getDispatchReportCSV(cookies, inputs) {
  return getApiClient(cookies, { timeout: REPORT_REQUEST_TIMEOUT_MS }).get(`${apiBaseUrl}/dispatch_report`, {
    params: {
      plant_ids: inputs.plant_ids,
      customer_ids: inputs.customer_ids,
      consignee_ids: inputs.consignee_ids,
      sales_rep_ids: inputs.sales_rep_ids,
      vehicle_ids: inputs.vehicle_ids,
      product_ids: inputs.product_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      report_format: inputs.report_format,
      report_type: inputs.report_type || 'detailed',
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

export async function getGrnReportCSV(cookies, inputs) {
  return getApiClient(cookies).get(`${apiBaseUrl}/goods_receipt_note_report`, {
    params: {
      plant_ids: inputs.plant_ids,
      vendor_ids: inputs.vendor_ids,
      vehicle_ids: inputs.vehicle_ids,
      product_ids: inputs.product_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      report_format: inputs.report_format,
      report_type: inputs.report_type || 'detailed',
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

export async function getDispatchReportSummaryCSV(cookies, inputs) {
  return getApiClient(cookies).get(`${apiBaseUrl}/dispatch_report_summary`, {
    params: {
      plant_ids: inputs.plant_ids,
      customer_ids: inputs.customer_ids,
      consignee_ids: inputs.consignee_ids,
      sales_rep_ids: inputs.sales_rep_ids,
      product_ids: inputs.product_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      report_format: inputs.report_format,
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

export async function getWorkScheduleReport(cookies,inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/work_schedule_report?plant_id=${inputs.plant_id}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
  .then(response => response.data);
}

export async function getWorkScheduleReportCSV(cookies, inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/work_schedule_report`, {
    params: {
      plant_id: inputs.plant_id,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

export async function getGstReportCSV(cookies, inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/gst_report`, {
    params: {
      plant_id: inputs.plant_id,
      customer_ids:inputs.customer_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}
export async function getWorkScheduleReportPDF(cookies,inputs) {
  let url= `${apiBaseUrl}/work_schedule_report?plant_id=${inputs.plant_id}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}&download_option=pdf`
    return getApiClient(cookies).get(url)
      .then(response => response.data);
}

export async function getUserReport(cookies,inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/user_report?user_ids=${inputs.user_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
  .then(response => response.data);
}

export async function getUserReportCSV(cookies, inputs) {
  return getApiClient(cookies)
  .get(`${apiBaseUrl}/user_report`, {
    params: {
      user_ids: inputs.user_ids,
      from_date: inputs.from_date,
      upto_date: inputs.upto_date,
      download_option: "csv"
    },
    responseType: 'blob' // Ensure the response is handled as a blob
  });
}

export async function getDcForTally(cookies,inputs) {

  return getApiClient(cookies)
  .get(`${apiBaseUrl}/dc_for_tally?plant_id=${inputs.plant_id}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
  .then(response => response.data);
}
export async function getCustomerDataReport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customer_data_report/`, { params })
    .then((response) => response.data);
}

export async function getCustomerDataTransactionDetails(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customer_data_report/transaction-details/`, { params })
    .then((response) => response.data);
}

export async function getCustomerSiteDocumentCounts(cookies, customerId) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customer_data_report/site-document-counts/`, {
      params: { customer_id: customerId },
    })
    .then((response) => response.data);
}

export async function getCustomerDataReportExport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customer_data_report/export/`, { params })
    .then((response) => response.data);
}

export async function getMarketingPersonReport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/marketing_person_report/`, { params })
    .then((response) => response.data);
}

export async function getEquipmentReport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/entity_salesrep/`, { params })
    .then((response) => response.data);
}

export async function getGoodsReceiptNote(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/goods_receipt_notes/`, { params })
    .then((response) => response.data);
}

export async function getAgeWiseReport(cookies) {

  // setTimeout(5000, () => {
  //   console.log('Waiting....');
    
  // });
  
  return fetch(`${apiBaseUrl}/accounting_master/`,{method: 'GET',headers: {
    'Authorization': `Token ${cookies['myToken']}`
  }})
  .then(response => response.json());
  
            // .then((data) => {
            //   return data;
            // });
}

export async function getSalesPostingReport(cookies) {

  // setTimeout(5000, () => {
  //   console.log('Waiting....');
    
  // });
  return fetch(`${apiBaseUrl}/entity_salesrep/`,{method: 'GET',headers: {
    'Authorization': `Token ${cookies['myToken']}`
  }})
  .then(response => response.json());
  
            // .then((data) => {
            //   return data;
            // });
}

export async function getAccountReceivableReport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/entity_salesrep/`, { params })
    .then((response) => response.data);
}

export async function getGSTReport(cookies) {
  return fetch(`${apiBaseUrl}/entity_salesrep/`,{method: 'GET',headers: {
    'Authorization': `Token ${cookies['myToken']}`
  }})
  .then(response => response.json());
}

export async function getReceiptReport(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/entity_salesrep/`, { params })
    .then((response) => response.data);
}


export async function getAgeWiseSummary(cookies) {

  // setTimeout(5000, () => {
  //   console.log('Waiting....');
    
  // });
  
  return fetch(`${apiBaseUrl}/entity_salesrep/`,{method: 'GET',headers: {
    'Authorization': `Token ${cookies['myToken']}`
  }})
  .then(response => response.json());
  
            // .then((data) => {
            //   return data;
            // });
}
export async function getLedgerAccountReport(cookies, inputs) {
  const plantId = inputs.plant_id || '*';
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/customer_ledger_report/?plant_id=${plantId}&customer_ids=${inputs.customer_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`)
    .then((response) => response.data);
}

export async function getAccountsReceivableAgewiseReport(cookies, inputs) {
  const params = new URLSearchParams({
    plant_id: inputs.plant_id || '*',
    customer_ids: inputs.customer_ids || '*',
    salesrep_ids: inputs.salesrep_ids || '*',
    as_on_date: inputs.as_on_date,
    report_type: inputs.report_type || 'summary',
  });
  if (inputs.age_buckets) {
    params.set('age_buckets', inputs.age_buckets);
  }
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/accounts_receivable_agewise_report/?${params.toString()}`)
    .then((response) => response.data);
}